export function generateRandomHexString(bytes = 16) {
  // Create a typed array to store random bytes
  const randomBytes = new Uint8Array(bytes);

  // Fill the array with cryptographically strong random values
  crypto.getRandomValues(randomBytes);

  // Convert each byte to a two-character hex string and join them
  return Array.from(randomBytes)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}

export const boldWordInText = (text, words = []) => {
  if (!words.length || !text) {
    return text;
  }

  const regex = new RegExp(`(${words.join('|')})`, 'g');
  const parts = text.split(regex);

  return parts.filter(part => part).map((part, index) => {
    if (words.includes(part)) {
      return <span key={index} className='font-bold bg-gray-100 p-1 rounded-md text-black'>{part}</span>;
    }
    return part;
  });
};

export const decompressData = (data) => {
  if (!data) return [];
  return Object.keys(data).map(key => {
      return {
          name: key,
          value: data[key],
          type: typeof data[key],
          customField: typeof data[key] === 'object' ? decompressData(data[key]) : null
      }
  });
}

export const escapeForBackend = (value) => {
  return value?.replace(/'/g, "`");
}